export default "__VITE_ASSET__Bm5VFcCe__ 480w, __VITE_ASSET__BPd_LeKd__ 768w, __VITE_ASSET__Czs6AI8E__ 1200w, __VITE_ASSET__BtpBXRv0__ 1920w";